import { css } from 'styled-components';

export const staffImportInProgressButtonStyles = css`
    && {
        background-color: #8d8d8d;
        border-color: #8d8d8d;
        color: #ffffff;
        opacity: 1;
    }
`;
